import React from "react";
import { Button, ButtonProps, Text } from "../../vanilla";
import { Nullable } from "../../types/utils";
import { Hit } from "../../store/ProductStore";

interface AddToBasketButtonProps extends ButtonProps {
    hit: Hit,
    displayPrice: Nullable<number>
    isPLPTile?: boolean
    isPDPPage?: boolean
}

export const ATBButton = React.forwardRef((props: AddToBasketButtonProps, ref: React.Ref<any>) => {
    const { 
        hit,
        displayPrice,
        isPLPTile,
        isPDPPage,
        ...rest 
    } = props

    const isButtonDisabled = !displayPrice 
                            || !hit.availableForDayAtStore 
                            || hit.isAddToCartDisabled === true 


    const disabledButtonText = () => {
        if (hit.disabledStatus === 'coming-soon') return 'Coming Soon'
        if (hit.disabledStatus === 'in-store-only') return 'In Store Only'
        return 'Out of Stock'
    }

    return (
        <Button 
        variant={!isButtonDisabled ? "primary" : "secondary"} 
        disabled={isButtonDisabled}
        size={(isPDPPage || isPLPTile) ? "smWide" : "sm"}
        paddingY={(isPDPPage || isPLPTile) ? "8px" : "0px"}
        {...rest}
        ref={ref}>
            <Text variant="unstyled" fontSize={isPDPPage ? "sm" : "inherit"} display={isPLPTile ? ['none', 'block'] : 'block'}>{!isButtonDisabled ? 'Add to Basket' : disabledButtonText()}</Text>
            <Text variant="unstyled" fontSize={isPLPTile ? "sm" : "inherit"} display={isPLPTile ? ['block', 'none'] : 'none'}>
                {!isButtonDisabled ? 'Add' : disabledButtonText()}
            </Text>
        </Button>
    )
})
